const alertBanner = [
    {
        selector: '[data-alert-banner]',
        path: { filename: 'alertBanner' },
    },
];

const alertPopup = [
    {
        selector: '[data-alert-popup]',
        path: { dirname: 'alertBanner', filename: 'alertPopup' },
    },
];

const cookieNotificationBanner = [
    {
        selector: '[data-cookie-notification]',
        path: { dirname: 'alertBanner', filename: 'cookieNotificationController' },
    },
];

export { alertBanner, alertPopup, cookieNotificationBanner };
